import type { DefaultTheme } from 'styled-components';

/**
 * Shared style helpers for un-custom-dashboard (PRD §5). Colours read from the
 * injected theme via `tok(theme, token, fallback)`, with the source hex only as
 * a fallback (mirrors `card-dashboard`/`landing-page`).
 */

/** Theme token lookup with a bespoke-source fallback. */
export const tok = (theme: DefaultTheme, name: string, fallback: string): string => {
  const v = theme.colors?.[name];
  return typeof v === 'string' ? v : fallback;
};

/** Mobile breakpoint — below this the card goes full-width. */
export const MOBILE = '697px';

/** Card elevation from the source `.border-custom` CSS (no themed token). */
export const CARD_SHADOW = '0px 1px 3px rgba(0, 0, 0, 0.2)';

/**
 * Format the raw balance to exactly 2 decimals in the active locale (PRD §6;
 * reproduces the source `flw.numberFormat(..., "2", ...)`). The DS `DataAmount`
 * takes a pre-formatted string + the currency code separately.
 */
export const formatAmount = (value: number, locale: string): string =>
  new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
